// extracted by mini-css-extract-plugin
module.exports = {"timeAgo":"_29jTk"};